import React from 'react';
import './customBtn.css'
import {Link} from "react-router-dom";

function CustomButton({href, text, bgColor, width, height, icon, color, isDisabled = false, buttonClicked,isLink=false}) {
    return (
        <>
            {
                isLink ?
                    <a to={href} style={{ cursor: isDisabled ? "no-drop":"pointer" , backgroundColor : bgColor, width:width, height:height,  color:isDisabled ? "#ff000063": color}} className="custom-btn btn-light btn-sm" href={isDisabled ? undefined : href}>
                        {icon && icon}
                        <span>{text}</span>
                    </a>
                    :
                    <Link onClick={(e)=>{
                        e.preventDefault()
                        buttonClicked()
                    }} to={href} style={{ cursor: isDisabled ? "no-drop":"pointer" , backgroundColor : bgColor, width:width, height:height,  color:isDisabled ? "#ff000063": color}} className="custom-btn btn-light btn-sm" href={isDisabled ? undefined : href}>
                        {icon && icon}
                        <span>{text}</span>
                    </Link>
            }
        </>
    );
}

export default CustomButton;